'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { clsx } from 'clsx/lite'
import { useEffect, useState } from 'react'

/**
 * The hairline under the navigation, on pages that open on a full-bleed hero card.
 *
 * At rest there is nothing for it to separate: the coloured card starts a few pixels below the bar
 * and does that job itself, so a line there reads as a stray rule across the top of the page. The
 * moment the page scrolls, content begins to pass *under* the bar and the line is what stops cards
 * appearing to float through it. So it fades in on the first scroll and stays.
 *
 * Pages that open on plain copy (about, contact, the blog) carry the border statically — see
 * `SiteNav` — because there the bar and the page are the same colour from the first pixel.
 */
export function NavBorder() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    // 8px rather than 0: a trackpad's elastic overscroll and a browser's scroll restoration both
    // land a pixel or two off zero, and a border that flickers on arrival is worse than no border.
    const onScroll = () => setScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div
      aria-hidden="true"
      className={clsx(
        'pointer-events-none absolute inset-x-0 bottom-0 h-px bg-mist-950/5 transition-opacity duration-200 dark:bg-white/10',
        scrolled ? 'opacity-100' : 'opacity-0',
      )}
    />
  )
}
